import L from 'leaflet';

export class MapEvents {
    constructor(mapComponent) {
        this.app = mapComponent;
    }

    setupPanoEvents() {
        if (!this.app.pano) return;

        window.addEventListener('changenode', () => {
            this.updateCurrentNodeMapVisibility();
        });
    }

    updateCurrentNodeMapVisibility() {
        if(!this.app.pano || !this.app.pano.getCurrentNode || !this.app.map) return;
        const currentNodeId = String(this.app.pano.getCurrentNode());
        
        let activeMarker = null;
        
        this.app.panoMarkers.eachLayer(marker => {
            if(marker.node_id === currentNodeId) {
                activeMarker = marker;
            }
            
            const fillColor = marker.is_aerial ? '#2196F3' : '#4CAF50';
            const radius = marker.is_aerial ? 12 : 7;
            
            marker.setStyle({ fillColor, color: '#333333', radius, weight: 2, fillOpacity: 0.9 }); 
        });

        if (activeMarker) {
            this.app.map.setView(activeMarker.getLatLng(), 18);
            
            if (!this.app.activePanoLayer) {
                const pulseIcon = L.divIcon({
                    className: 'pulse-active-overlay',
                    html: '<div class="pulse-active-marker"></div>',
                    iconSize: [24, 24],
                    iconAnchor: [12, 12]
                });
                this.app.activePanoLayer = L.marker(activeMarker.getLatLng(), {
                    icon: pulseIcon,
                    zIndexOffset: 1000,
                    /*
                     * Decoration only -- it marks where you are, it is not something to click.
                     * Leaving it interactive made Leaflet tag it .leaflet-interactive, whose
                     * pointer-events:auto re-enabled hit testing inside the closed map modal and
                     * left a 24x24 dead spot over the panorama that swallowed drags.
                     */
                    interactive: false,
                    keyboard: false
                }).addTo(this.app.map);
            } else {
                this.app.activePanoLayer.setLatLng(activeMarker.getLatLng());
            }
        }
    }
}